import React from 'react';
import PropTypes from 'prop-types';
import {
  EVDialogContent,
  EVDialogActions,
  EVButton,
  EVDialog,
  EVBox,
  EVTypography,
  makeStyles,
  EVReportProblemOutlined,
} from '@eagleview/ev-comp-library';
import { withTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    margin: ` ${theme.spacing(2)}px ${theme.spacing(3)}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleLine: {
    width: '100%',
    height: theme.spacing(0.125),
    backgroundColor: '#DEDFE2',
  },
  titleText: {
    fontSize: theme.spacing(2.5),
    fontWeight: 600,
    color: theme.evPalette.charcoal[900],
  },
  dialogContentCotainer: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  dialogText: {
    fontSize: theme.spacing(1.75),
    color: theme.evPalette.charcoal[900],
  },
  dialogContent: {
    display: 'flex',
    maxWidth: theme.spacing(58.75),
    backgroundColor: '#FFF6DD',
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    gap: theme.spacing(0.75),
    marginTop: theme.spacing(2),
  },
  dialogNote: {
    fontWeight: theme.typography.h3.fontWeight,
  },
  actionContainer: {
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    gap: theme.spacing(1),
  },
  button: {
    fontSize: theme.spacing(1.75),
    fontWeight: 500,
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px ${theme.spacing(1)}px ${theme.spacing(2)}px`,
    textTransform: 'none',
    borderRadius: `${theme.spacing(0.5)}px`,
    height: theme.spacing(4.5),
    border: `${theme.spacing(0.125)}px solid ${theme.evPalette.ocean[600]}`,
  },
  alertIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2.5),
    color: theme.evPalette.marigold[500],
  },
}));

const ImpersonationReloadDialog = (props) => {
  const classes = useStyles();
  const {
    t, openDialog, handleReload,
  } = props;

  return (
    <>
      <EVDialog
        id="impersonation-reload-dialog"
        open={openDialog}
      >
        <EVBox className={classes.titleContainer}>
          <EVTypography className={classes.titleText}>{t('SessionChange')}</EVTypography>
        </EVBox>
        <EVBox className={classes.titleLine} />
        <EVDialogContent>
          <EVBox className={classes.dialogContentCotainer}>
            <EVTypography variant="body1" className={classes.dialogText}>
              {t('SessionChangeMessage')}
            </EVTypography>
            <EVBox className={classes.dialogContent}>
              <EVReportProblemOutlined className={classes.alertIcon} />
              <EVTypography variant="body1" className={classes.dialogText}>
                <span className={classes.dialogNote}>{t('Note')}</span>
                <span>{t('SessionChangeWarning')}</span>
              </EVTypography>
            </EVBox>
          </EVBox>
        </EVDialogContent>
        <EVDialogActions className={classes.actionContainer}>
          <EVButton
            id="reload-btn"
            color="primary"
            className={classes.button}
            variant="outlined"
            onClick={handleReload}
          >
            {t('Reload')}
          </EVButton>
        </EVDialogActions>
      </EVDialog>
    </>
  );
};

ImpersonationReloadDialog.propTypes = {
  /**
   * @property {func} - translation function
   */
  t: PropTypes.func.isRequired,
  /**
   * @property {bool} - flag to control open/close of dialog box
   */
  openDialog: PropTypes.bool.isRequired,
  /**
   * @property {func} - method called on success action of dialog box
   */
  handleReload: PropTypes.func.isRequired,
};

export default withTranslation()(ImpersonationReloadDialog);
